//@ts-nocheck

import { waitForMs } from '../../helpers';
import { lang } from '../../constants';

export default () => {
  // Modal Download Button Activater
  let caseStudyModalTimer: ReturnType<typeof setInterval>;

  // Click Download Button
  $('.case-study-banner__button').on('click', async function () {
    caseStudyModalTimer = setInterval(() => {
      let valid = true;

      $.each($('.case-study-modal__input input'), (idx, item) => {
        if (!(item as HTMLSelectElement).checkValidity()) {
          valid = false;
          return;
        }
      });

      if (!$('#case-study-modal-agb').prop('checked')) {
        valid = false;
      }

      valid
        ? $('.case-study-modal__button').addClass('active')
        : $('.case-study-modal__button').removeClass('active');
    }, 350);

    $('.case-study-modal').css('display', 'flex');
    await waitForMs(50);
    $('.case-study-modal').addClass('opened');
  });

  // Close Modal
  $(`.case-study-modal`).on('click', async function (e) {
    if ($(e.target).hasClass('case-study-modal')) {
      clearInterval(caseStudyModalTimer);
      $('.case-study-modal').removeClass('opened');
      await waitForMs(350);
      $('.case-study-modal').hide();
    }
  });

  $('#case-study-modal-close, #case-study-modal-response-success-close').on(
    'click',
    async function () {
      clearInterval(caseStudyModalTimer);
      $('.case-study-modal').removeClass('opened');
      await waitForMs(350);
      $('.case-study-modal').hide();
    }
  );

  // Click input
  $('.case-study-modal__input').on('click', function () {
    const focused = $(this).hasClass('focused');
    if (!focused) {
      $(this).addClass('focused').find('input').trigger('focus');
    }
  });

  // Focus
  $('.case-study-modal__input input').on('focus', function () {
    $(this).parent().addClass('focused');
  });

  // Blur
  $('.case-study-modal__input input').on('blur', function () {
    if (($(this).val() as string).length == 0) {
      $(this).parent().removeClass('focused');
    }
  });

  // Form Submit
  $('#case-study-modal-form').on('submit', function (e) {
    e.preventDefault();

    const CASE_STUDY_STORAGE_KEY = 'CASE_STUDY_STORAGE_KEY';

    if (localStorage.getItem(CASE_STUDY_STORAGE_KEY) !== null) {
      $('.case-study-modal__card').addClass('error');
      return;
    }

    $('.case-study-modal__card').addClass('submitting');

    const data = {};
    const formData = $(this).serializeArray();
    formData.forEach(item => {
      data[item.name] = item.value;
    });

    const { name, surname, email } = data;

    $.ajax({
      url: '/ui/Banners@CaseStudyMail',
      type: 'post',
      data: { name: `${name} ${surname}`, mail: email, firma: '', lang },
      async: true,
      success: async function (data) {
        // console.log('data');
        // console.log(data);
        const json = JSON.parse(data);
        // console.log(json);

        // return;

        if (json.status) {
          // success
          localStorage.setItem(CASE_STUDY_STORAGE_KEY, '1');

          $('.case-study-modal__card').addClass('success');

          setTimeout(() => {
            $('#case-study-modal-response-success-lottie')
              .trigger('stop')
              .trigger('play');
            $('#case-study-modal-response-success-lottie');
          }, 500);
        } else {
          // error
          $('.case-study-modal__card').addClass('error');
        }

        // const fileSrc = $('.case-study-banner__button').data('src');
        // console.log({ fileSrc });
        // window.open(fileSrc, '_blank');
        // $('.case-study-modal').trigger('click');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(JSON.stringify(jqXHR));
      },
    });
  });
};
